<script>
import { defineComponent } from "vue";
import { mapActions, mapState } from "pinia";
import { useAlertsStore } from "./stores/alerts";
import { useUserStore } from "./stores/user";

export default defineComponent({
  name: "App",
  data() {
    return {
      isNavbarCollapsed: true,
      loading: false,
    };
  },
  mounted() {
    this.$router.beforeEach(() => {
      this.loading = true;
    });
    this.$router.afterEach(() => {
      this.loading = false;
    });
  },
  computed: {
    ...mapState(useUserStore, ["isLoggedin"]),
    ...mapState(useAlertsStore, ["alerts"]),
  },
  methods: {
    ...mapActions(useAlertsStore, { closeAlert: "close", addAlert: "add" }),
  },
});
</script>

<template>
  <header>
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <img
        src="/src/assets/img/lullogo.png"
        class="nav-image"
        alt="Logo of the Organizer"
      />
      <RouterLink to="/" class="navbar-brand">Crewtool</RouterLink>
      <button
        v-if="isLoggedin"
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
        @click="isNavbarCollapsed = !isNavbarCollapsed"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div
        class="navbar-collapse"
        :class="{ collapse: isNavbarCollapsed }"
        id="navbarSupportedContent"
        @click="isNavbarCollapsed = true"
      ></div>
    </nav>
  </header>
  <main role="main" class="flex-shrink-0">
    <div class="container">
      <div
        v-for="alert of alerts"
        :key="alert.id"
        class="alert"
        :class="'alert-' + alert.type"
        role="alert"
      >
        {{ alert.message }}
        <button
          type="button"
          class="close"
          aria-label="Close"
          @click="closeAlert(alert.id)"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <RouterView />
    </div>
    <div class="page-spinner" v-if="loading">
      <span class="spinner-border" role="status" aria-hidden="true"></span>
    </div>
    <div id="modalTeleport"></div>
  </main>

  <footer class="hidden-print">
    &copy; 2022 itcreatesmedia |
    <a href="https://itcreates.media/privacy-policy" target="_blank"
      >Datenschutz</a
    >
    | <a href="https://itcreates.media/impressum" target="_blank">Impressum</a>
  </footer>
</template>
<style>
@import "bootstrap";
@import "font-awesome";
</style>
<style lang="scss">
/* You can add global styles to this file, and also import other style files */
$color-light: #9b9b9b;

body,
html {
  font-family: "Raleway", sans-serif;
  font-size: 16px;
  font-weight: 300;
}

html {
  min-height: 100%;
  position: relative;
}

body {
  padding-bottom: 80px;
  background-color: #eeeeee;
}

@page {
  size: auto;
  margin: 0mm;
}

@media print {
  body {
    margin: 20mm;
  }
  .pagebreak {
    page-break-after: always;
  }
}

.navbar {
  justify-content: space-around;
}

.nav-image {
  max-height: 40px;
}

.navbar-brand {
  font-size: 30px;
  font-family: "Raleway", sans-serif;
  font-weight: 100;
  color: #4d4d4d;
  margin-left: 0.5em;
}

@media (max-width: 350px) {
  .navbar-brand {
    font-size: 24px;
  }
  .nav-item {
    font-size: inherit;
  }
}
@media (max-width: 1210px) {
  .nav-item {
    font-size: 14px;
  }
}
@media (min-width: 1210px) {
  .navbar-brand {
    margin-left: 1em;
  }
}

footer {
  text-align: center;
  width: 100%;
  background-color: rgba(255, 255, 255, 1);
  padding: 10px 15px;
  position: absolute;
  bottom: 0;
  min-height: 44px;
}

.input-group.is-invalid {
  ~ .invalid-feedback {
    display: block;
  }
}

h1 {
  font-family: "Walter Turncoat", sans-serif;
  font-weight: 700;
  font-size: 24px;
  text-align: center;

  &.small {
    font-family: "Raleway", sans-serif;
    font-weight: 300;
    font-size: 24px;
    color: $color-light;
  }
}

h2 {
  font-family: "Raleway", sans-serif;
  font-weight: 700;
  font-size: 24px;

  small,
  &.small {
    font-family: "Raleway", sans-serif;
    font-weight: 300;
    color: $color-light;
  }
}

h3 {
  font-family: "Raleway", sans-serif;
  font-weight: 400;
  font-size: 18px;
}

hr {
  border-top: #4d4d4d 1px solid;
}

.btn,
.form-control,
.btn-group,
.btn-group-sm > .btn {
  border-radius: 0;
}

.table td {
  border-top: #bbbbbb 1px solid;
  padding: 8px 0;
  vertical-align: middle;
}

.table tr:first-of-type td,
.table tr:first-of-type th {
  border-top: none;
}
.comma-after:not(.comma-after:last-of-type)::after {
  content: ", ";
}
.quill-generated-text {
  margin-bottom: 1rem;

  p {
    margin-bottom: 0;
  }
}
.team-description {
  font-size: smaller;
}
.task-description {
  font-size: smaller;
}
</style>

<style scoped>
main > .container {
  padding-top: 30px;
}
.page-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.8);
  cursor: progress;
}
</style>
